export default __webpack_public_path__ + "static/media/PartnersImg.23445541.svg";